import type {PageRouteConfig} from '@router';

import CustomDeal from 'modules/Services/PromotionCenter/CustomDeal/CustomDeal';
import {routes} from 'routes/routes';

export function createPromotionCenterCustomDealRoute(): PageRouteConfig {
  return {
    element: <CustomDeal />,
    layout: {
      title: 'تخفیف',
      hasNavigate: false,
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: true,
      link: routes.PROMOTION_CENTER,
      extra: <i />
    }
  };
}
